/* eslint-disable @typescript-eslint/no-deprecated, @typescript-eslint/naming-convention */
import { trigger, state, style, transition, animate } from '@angular/animations';

export const Animations = {
  get openClose() {
    return trigger('openClose', [
      state(
        'open',
        style({
          opacity: '1',
          height: '*',
        }),
      ),
      state(
        'closed',
        style({
          height: '0',
          opacity: '0',
        }),
      ),
      transition('open => closed', animate('200ms')),
      transition('closed => open', animate('200ms')),
    ]);
  },

  get slideInOut() {
    return trigger('slideInOut', [
      transition(':enter', [style({ transform: 'translateY(-100%)' }), animate('200ms', style({ transform: 'translateY(0)' }))]),
      transition(':leave', [style({ transform: 'translateY(0)' }), animate('200ms', style({ transform: 'translateY(-100%)' }))]),
    ]);
  },
};
